export default {
  "content": "<title>Server</title><ellipse cx=\"256\" cy=\"128\" rx=\"192\" ry=\"80\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M448 214c0 44.18-86 80-192 80S64 258.18 64 214m384 86c0 44.18-86 80-192 80S64 344.18 64 300\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M64 127.24v257.52C64 428.52 150 464 256 464s192-35.48 192-79.24V127.24\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};